module.exports = __webpack_public_path__ + "img/photo-3-m.e2e186e1.png";